import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRbacApiClient } from "../../api/apiClients";
import { User, Workspace } from "../../interfaces/rbac";

const useUsers = () => {
  const apiClient = useRbacApiClient<User[]>();

  return useQuery({
    queryKey: ["users"],
    queryFn: () => apiClient("GET", "/user"),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 15,
  });
};

const useWorkspaces = () => {
  const apiClient = useRbacApiClient<Workspace[]>();

  return useQuery({
    queryKey: ["workspace"],
    queryFn: () => apiClient("GET", "/workspace"),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 15,
  });
};

export { useUsers, useWorkspaces };
